import React from 'react';
import { Badge } from '@/components/ui/badge';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ServiceType } from '@/types/filters';

interface ServiceFilterProps {
  selected: ServiceType[];
  onChange: (services: ServiceType[]) => void;
  className?: string;
}

const serviceConfig = {
  all: { label: 'Todos', color: 'bg-figma-text-secondary' },
  n8n: { label: 'n8n', color: 'bg-orange-500' },
  vapi: { label: 'Vapi AI', color: 'bg-purple-500' },
  openai: { label: 'OpenAI', color: 'bg-green-500' },
  anthropic: { label: 'Anthropic', color: 'bg-blue-500' },
  gemini: { label: 'Gemini', color: 'bg-yellow-500' },
  elevenlabs: { label: 'ElevenLabs', color: 'bg-pink-500' },
};

export const ServiceFilter: React.FC<ServiceFilterProps> = ({
  selected = ['all'],
  onChange,
  className
}) => {
  const handleToggle = (service: ServiceType) => {
    if (service === 'all') {
      onChange(['all']);
    } else {
      const newSelected = selected.includes(service)
        ? selected.filter(s => s !== service)
        : [...selected.filter(s => s !== 'all'), service];
      
      onChange(newSelected.length === 0 ? ['all'] : newSelected);
    }
  };

  const isAllSelected = selected.includes('all');

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {Object.entries(serviceConfig).map(([key, config]) => {
        const service = key as ServiceType;
        const isSelected = isAllSelected ? service === 'all' : selected.includes(service);
        
        return (
          <Badge
            key={service}
            variant={isSelected ? "default" : "outline"}
            className={cn(
              "cursor-pointer transition-all duration-200 hover:scale-105 border-figma-primary/20",
              isSelected 
                ? cn(config.color, "text-white border-transparent shadow-figma") 
                : "text-figma-text-secondary hover:border-figma-primary/40 hover:bg-figma-primary/5"
            )}
            onClick={() => handleToggle(service)}
          >
            {config.label}
            {isSelected && service !== 'all' && (
              <X className="ml-1 h-3 w-3" />
            )}
          </Badge>
        );
      })}
    </div>
  );
};